<template>
  <b-container fluid>
    <b-row>
      <b-col class="tsny_nav" lg="auto">
        <b-row
          ><img
            id="logo"
            src="../../assets/svg/TSNY_Logo_Init.svg"
            alt=""
            @click="home()"
        /></b-row>
        <b-row v-if="isAdmin" class="nav_link" @click="index()">
          <div>Home</div>
        </b-row>
        <b-row v-if="!isAdmin" class="nav_link" @click="home()">
          <div>Home</div>
        </b-row>
        <b-row
          v-if="!isAdmin && courses && courses.length > 1"
          class="nav_link"
          @click="toCourses()"
        >
          <div>
            <span>My Courses</span
            ><i
              class="fa fa-exclamation-circle alert-icon"
              v-if="isStaff && reportDue"
            />
          </div>
        </b-row>
        <b-row class="nav_link" @click="profile()">
          <div>Profile</div>
        </b-row>
        <b-row v-if="isAdmin" class="nav_link" @click="userAdmin()">
          <div>User Administration</div>
        </b-row>
        <b-row v-if="isAdmin" class="nav_link" @click="courseAdmin()">
          <div>Course Administration</div>
        </b-row>
        <b-row v-if="isAdmin" class="nav_link" @click="courseRelationships()">
          <div>Course Relationships</div>
        </b-row>
        <b-row v-if="!isAdmin" class="nav_link" @click="scoreReports">
          <div>Score Reports</div>
        </b-row>
        <b-row class="nav_link" @click="questionBank()">
          <div>Question Bank</div>
        </b-row>
        <b-row class="nav_link">
          <a href="https://www.tutoringserviceofnewyork.com/" target="_blank"
            >TSNY</a
          >
        </b-row>
        <b-row class="nav_link" @click="signOut()">
          <div>Sign Out</div>
        </b-row>
      </b-col>
      <b-col>
        <b-row>
          <router-view></router-view>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import StoreConstants from "../../store/services/StoreConstants";

export default {
  name: "Main",
  computed: {
    ...mapGetters({
      courses: StoreConstants.GETTERS.COURSES,
      reportDueGetter: StoreConstants.GETTERS.IS_SESSION_REPORT_DUE,
      isAdmin: StoreConstants.GETTERS.IS_ADMIN,
      isStaff: StoreConstants.GETTERS.IS_STAFF,
      user: StoreConstants.GETTERS.USER
    }),
    reportDue() {
      let reportDue = false;

      for (let i = 0; i < this.courses.length; i++) {
        if (this.reportDueGetter(this.courses[i]._id)) {
          reportDue = true;
          break;
        }
      }

      return reportDue;
    }
  },
  mounted: function() {
    let $comp = this;

    if ($comp.isAdmin) return;

    $comp.home();
  },
  methods: {
    ...mapActions({
      vuexSignOut: StoreConstants.ACTIONS.SIGN_OUT
    }),
    index: function() {
      this.$router.push("/");
    },
    home: function() {
      if (!this.courses.length) return;

      this.$router.push({
        name: "Course",
        params: { id: this.courses[0]._id }
      });
    },
    toCourses: function() {
      this.$router.push("/courses");
    },
    profile: function() {
      this.$router.push({
        name: "Profile"
      });
    },
    signOut: function() {
      this.$router.replace("/login", this.vuexSignOut);
    },
    courseAdmin: function() {
      this.$router.push({
        name: "CourseAdministration"
      });
    },
    courseRelationships: function() {
      this.$router.push({
        name: "CourseRelationships"
      });
    },
    userAdmin: function() {
      this.$router.push({
        name: "UserAdministration"
      });
    },
    scoreReports() {
      this.$router.push({
        name: "ScoreReports"
      });
    },
    questionBank: function() {
      this.$router.push({
        name: "QuestionBank"
      });
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/css/styles.scss";
</style>

<style scoped>
.tsny_nav {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  background-color: #f8f8f8;
  height: 100vh;
  box-shadow: 2px 0 3px #eeeeee;
  width: 275px;
}
#logo {
  width: 175px;
  height: auto;
  margin: 55px 50px;
}
#logo:hover {
  cursor: pointer;
}
.nav_link {
  height: 65px;
  text-align: left;
  padding-left: 25px;
  padding-right: 25px;
}
.nav_link:hover {
  cursor: pointer;
}
.nav_link > div,
.nav_link > a {
  width: 100%;
  padding-top: 20px;
  padding-left: 20px;
  box-shadow: 0 2px 1px #ededed;
  font-family: "expo-sans-pro", sans-serif;
  font-size: 1.3em;
  text-decoration: none;
  color: #363636;
}

.alert-icon {
  padding-left: 0.5em;
}
</style>
